import React from "react";

import parlorSocialClub from "assets/graphics/icons/parlor-social-club.svg";

import parlor from "assets/documents/Parlor Membership.pdf";

import "screens/secret-pdf/component/view.scss";

const SecretPdfView = () => (
  <main className="secret-pdf">
    <img
      className="secret-pdf__logo"
      src={parlorSocialClub}
      alt="parlor social club"
    />
    <div className="secret-pdf__form">
      <a
        className="secret-pdf__submit"
        href={parlor}
        download
        onClick={() => window.dataLayer.push({ event: "downloadPdfClicked" })}
      >
        Download PDF
      </a>
    </div>
  </main>
);

export default SecretPdfView;
